/* eslint-disable react/jsx-filename-extension */
import React from 'react';

import BrandIcon from 'parts/BrandIcon';
import Button from 'elements/Button';

export default function Footer() {
  return (
    <div className="bg-gradient-to-b from-gray-50 to-white border-t border-gray-200 pb-8 pt-12">
      <div className="container flex-col mx-auto px-4">
        <div className="flex flex-col sm:flex-row gap-8 sm:gap-12 lg:gap-16 justify-center">
          <div className="w-full sm:w-1/3 flex-col">
            <BrandIcon />
            <p className="w-full text-base text-gray-600 font-light mt-4 leading-relaxed">
              We work as your tech partners enabling digital transformation, process
              re-engineering, and building solutions that scale as per business needs using
              ultra-modern technologies.
            </p>
          </div>
          <div className="w-full sm:w-1/3">
            <h1 className="text-lg font-semibold text-theme-blue pt-4 pb-3">
              Office
            </h1>
            <div className="space-y-2">
              <p className="text-base text-gray-600 font-light hover:text-theme-purple transition-colors duration-200">
                erapid.tech@gmail.com
              </p>
              <p className="text-base text-gray-600 font-light hover:text-theme-purple transition-colors duration-200">
                +91 9311032818
              </p>
              <p className="text-base text-gray-600 font-light">
                91springboard Mohan Estate, Delhi, India
              </p>
            </div>
          </div>
          <div className="w-full sm:w-1/3">
            <h1 className="text-lg font-semibold text-theme-blue pt-4 pb-3">
              Social
            </h1>
            <div className="space-y-2">
              <Button href="https://www.linkedin.com/company/erapid-technologies" type="link" target="_blank" className="flex text-base text-gray-600 font-light hover:text-theme-purple transition-colors duration-200" isExternal>
                LinkedIn
              </Button>
              <Button href="https://github.com/Erapid-Tech" type="link" target="_blank" className="flex text-base text-gray-600 font-light hover:text-theme-purple transition-colors duration-200" isExternal>
                Github
              </Button>
            </div>
          </div>
        </div>
        <div className="flex-col text-center mt-10 pt-6 border-t border-gray-200">
          <p className="text-base text-gray-500 font-light">
            Copyright 2024 - All rights reserved - ERapid Technologies
          </p>
        </div>
      </div>
    </div>
  );
}
